export default __webpack_public_path__ + "static/media/option_icon.1c29109e.png";